import moment from 'moment-timezone'
import { get, isNull, isEmpty, find, isUndefined, sortBy } from "lodash"
import Property from "../model/property";

const storeFunction = {

  isHourMinuteInRange(value, range) {
    return value >= range[0] && value <= range[1]
  },

  filterRowsByTimeBased(node) {
    let timeZone = get(Property.getData(), 'time_zone', null)
    if (isNull(timeZone)) {
      timeZone = 'Etc/UTC'
    }
    let shouldShow = false

    // now date
    const nowUtc = moment.utc().tz(timeZone)
    const dayOfWeek = nowUtc.day()

    if (!node) {
      return true;
    }

    if (node.end_date != null && node.start_date != null) {
      const startDate = moment.utc(node.start_date).tz(timeZone)
      const endDate = moment.utc(node.end_date).tz(timeZone)
      if (nowUtc < startDate || nowUtc > endDate || (nowUtc < startDate && nowUtc > endDate) || startDate > endDate) {
        return false
      }
    }
    
    const weekday_frequency = get(node,'weekday_frequency',[])
    const start_time = get(node,'start_time',null)
    const end_time = get(node,'end_time',null)
    if (!isEmpty(weekday_frequency) ||
      (!isNull(start_time) && !isNull(end_time))) {
      const startTime = node.start_time ? moment.utc(node.start_time, 'HH:mm:ss').tz(timeZone) : moment().startOf("day")
      const endTime = node.end_time ? moment.utc(node.end_time, 'HH:mm:ss').tz(timeZone) : startTime.clone().endOf("day")
      const isStartAfterFinish = moment(startTime.format("HH:mm"), "HH:mm").isAfter(moment(endTime.format("HH:mm"), "HH:mm"))
      const ranges = {}

      const allDays = [0, 1, 2, 3, 4, 5, 6]
      const nodeWeekdayFrequency = (node.weekday_frequency != null && node.weekday_frequency.length > 0) ? node.weekday_frequency : allDays
      for (const weekDay of nodeWeekdayFrequency) {
        let aDay = moment.utc().day(weekDay).tz(timeZone).day()
        if (!isNull(node.start_time)) {
          aDay = moment.utc(node.start_time, 'HH:mm:ss').day(weekDay).tz(timeZone).day()
        }
        const day = ranges[aDay] ? ranges[aDay] : []
        if (isStartAfterFinish) {

          const range1 = []
          range1.push(startTime.format("HH:mm"))
          range1.push("23:59")
          day.push(range1)
          ranges[aDay] = day

          let nDay = aDay + 1
          if (nDay > 6) {
            nDay = 0
          }
          const nextDay = ranges[nDay] ? ranges[nDay] : []
          const range2 = []
          range2.push(startTime.format("00:00"))
          range2.push(endTime.format("HH:mm"))
          nextDay.push(range2)

          ranges[nDay] = nextDay

        } else {
          const range1 = []
          range1.push(startTime.format("HH:mm"))
          range1.push(endTime.format("HH:mm"))
          day.push(range1)
          ranges[aDay] = day
          ranges[aDay] = day
        }

      }

      if (ranges[dayOfWeek]) // matches a day
      {
        const hhMM = nowUtc.format("HH:mm")
        for (const aRange of ranges[dayOfWeek]) {
          const result = this.isHourMinuteInRange(hhMM, aRange)
          shouldShow |= result
        }
      }
      return !!shouldShow
    } else {
      return true
    }
  },

  checkTimeAvailability(parentNode, sectionData) {
    const presets = Property.getPreset() || {}
    const ampm = presets.standard_time_hour_format === "12-hour"
    const timeFormat = ampm ? "hh:mm A" : "HH:mm"
    let timeZone = get(Property.getData(), 'time_zone', null)
    if (isNull(timeZone)) {
      timeZone = 'Etc/UTC'
    }
    const categoryAvailability = this.filterRowsByTimeBased(parentNode)
    const productAvailability = this.filterRowsByTimeBased(sectionData)

    let displayText = null
    let insideTimeBased = true
  
    const categoryStartTime = get(parentNode, 'start_time', null)
    const categoryEndTime = get(parentNode, 'end_time', null)
  
    const startTimeProduct = get(sectionData, 'start_time', null)
    const endTimeProduct = get(sectionData, 'end_time', null)
  
    let frequencyDayCategory = get(parentNode, 'weekday_frequency', [])
    let frequencyDayProduct = get(sectionData, 'weekday_frequency', [])
    
    let day = ""
    if (frequencyDayCategory || frequencyDayProduct || (startTimeProduct && endTimeProduct) || (categoryStartTime && categoryEndTime)) {
      if (isNull(startTimeProduct) && isNull(endTimeProduct) && frequencyDayProduct.length === 0) {
        if (categoryAvailability) {
          insideTimeBased = true
        } else {
          insideTimeBased = false
          if (!isEmpty(frequencyDayCategory)) {
            frequencyDayCategory = sortBy(frequencyDayCategory)
          }
          for (let i = 0; i < frequencyDayCategory.length; i++) {
            const frequencyDay = isNull(categoryStartTime) ? moment().day(parseInt(frequencyDayCategory[i], 10)).format('dddd')
                : moment.utc(categoryStartTime, 'HH:mm:ss').day(parseInt(frequencyDayCategory[i], 10)).tz(timeZone).format('dddd')
            if (frequencyDayCategory.length === 1 || i === 0) {
              day += frequencyDay
            } else if (i === frequencyDayCategory.length - 1) {
              day += ` and ${frequencyDay}`
            } else {
              day += `, ${frequencyDay}`
            }
          }
        
          if (frequencyDayCategory.length > 0) {
            if (!isNull(categoryStartTime) && !isNull(categoryEndTime)) {
              const startTime = moment.utc(categoryStartTime, 'HH:mm:ss').tz(timeZone).format(timeFormat)
              const endTime = moment.utc(categoryEndTime, 'HH:mm:ss').tz(timeZone).format(timeFormat)
              displayText = `This item is only available on ${day} from ${startTime} - ${endTime}`
            } else {
              displayText = `This item is only available on ${day}`
            }
          } else if (categoryStartTime && categoryEndTime) {
            const startTime = moment.utc(categoryStartTime, 'HH:mm:ss').tz(timeZone).format(timeFormat)
            const endTime = moment.utc(categoryEndTime, 'HH:mm:ss').tz(timeZone).format(timeFormat)
            displayText = `This item is only available from ${startTime} - ${endTime}`
          }
        
        }
      } else {
        if (productAvailability) {
          insideTimeBased = true
        } else {
          insideTimeBased = false
          if (!isEmpty(frequencyDayProduct)) {
            frequencyDayProduct = sortBy(frequencyDayProduct)
          }
         for (let i = 0; i < frequencyDayProduct.length; i++) {
            const frequencyDay = isNull(startTimeProduct) ?
                moment().day(parseInt(frequencyDayProduct[i], 10)).format('dddd')
                : moment.utc(startTimeProduct, 'HH:mm:ss').day(parseInt(frequencyDayProduct[i], 10))
                    .tz(timeZone).format('dddd')
            if (frequencyDayProduct.length === 1 || i === 0) {
              day += frequencyDay
            } else if (i === frequencyDayProduct.length - 1) {
              day += ` and ${frequencyDay}`
            } else {
              day += `, ${frequencyDay}`
            }
          }
        
          if (frequencyDayProduct.length > 0 && startTimeProduct && endTimeProduct) {
            const startTime = moment.utc(startTimeProduct, 'HH:mm:ss').tz(timeZone).format(timeFormat)
            const endTime = moment.utc(endTimeProduct, 'HH:mm:ss').tz(timeZone).format(timeFormat)
            displayText = `This item is only available on ${day} from ${startTime} - ${endTime}`
          } else if (frequencyDayProduct.length > 0) {
            displayText = `This item is only available on ${day}`
          } else if (startTimeProduct && endTimeProduct)  {
            const startTime = moment.utc(startTimeProduct, 'HH:mm:ss').tz(timeZone).format(timeFormat)
            const endTime = moment.utc(endTimeProduct, 'HH:mm:ss').tz(timeZone).format(timeFormat)
            displayText = `This item is only available from ${startTime} - ${endTime}`
          }
        }
      }
    }

    return { insideTimeBased, displayText }
  },

  numberWithCommas(price) {
    // 2 == represent that we can use to check undefined or null
    if (price == null) {
      return 0
    }
    return price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },

  resizeImage(img, width, height) {
    return img.replace("upload/", `upload/w_${width},h_${height},c_fill,dpr_2/`);
  },

  availableInDate(guestService) {
    const nowUtc = moment.utc()
    if (!guestService.display_only) {
      this.setDisplayOnly(guestService)
    }
    
    // date range
    if (get(guestService,'end_date',null) != null && get(guestService,'start_date',null) != null) {
      const startDate = moment.utc(guestService.start_date)
      const endDate = moment.utc(guestService.end_date)
      if (nowUtc < startDate || nowUtc > endDate || (nowUtc < startDate && nowUtc > endDate) || startDate > endDate) {
        return false
      }
    }
    return true
  },
  
  setDisplayOnly(guestService) {
    let startTime = moment.utc(get(guestService,'start_time',null))
    let endTime = moment.utc(get(guestService,'end_time',null))
  
    // day frequency
    const dayFrequency = get(guestService,'weekday_frequency',[])
    let dayOfWeek = moment.utc().day()
    if (!isEmpty(dayFrequency)) {
      let productFrequency = find(dayFrequency,data => data === dayOfWeek)
      if (isUndefined(productFrequency)){
        if (endTime.valueOf() < startTime.valueOf()) {
          dayOfWeek = dayOfWeek === 0 ? 6 : dayOfWeek - 1
          productFrequency = find(dayFrequency,data => data === dayOfWeek)
          if (isUndefined(productFrequency)) {
            guestService.display_only = true
            return
          }
        } else {
          guestService.display_only = true
          return
        }
      }
    }
  
    // time frequency
    if (null !== get(guestService,'end_time',null)) {
      const nTime = moment.utc().format("HH:mm")
      const nowTime = moment.utc(nTime,"HH:mm").valueOf()
  
      this.setTime(startTime,endTime)
      if (startTime.valueOf() > nowTime.valueOf() || nowTime.valueOf() > endTime.valueOf()) {
        guestService.display_only = true
      }
    }
  },
  
  isAvailable(node) {
    if (isUndefined(node)) {
      return false
    }
    if (node.display_only) {
      return true
    }
    return false
  },
  
  setTime(startTime,endTime){
    // set start time
    if (!isNull(startTime)) {
      const sTime = moment.utc(startTime).format("HH:mm")
      startTime = moment.utc(sTime,"HH:mm").valueOf()
    }
    // set end time
    if (!isNull(endTime)) {
      const eTime = moment.utc(endTime).format("HH:mm")
      if (startTime > endTime) {
        endTime = moment.utc(eTime,"HH:mm").add( 1,'days').valueOf()
      } else {
        endTime = moment.utc(eTime,"HH:mm").valueOf()
      }
    }
  }
}

export default storeFunction
